import { jwtDecode } from "jwt-decode";

function getUsernameFromToken() {
  const idToken = localStorage.getItem('msal.idtoken');
  if (idToken) {
    try {
      const decodedToken = jwtDecode(idToken); // updated here
      if (decodedToken && decodedToken.given_name) {
        return decodedToken.given_name;
      } else {
        console.error("Error: Decoded token does not contain 'given_name'.");
        return null;
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  } else {
    console.error('Error: ID token not found in localStorage.');
    return null;
  }
}

export default getUsernameFromToken;
